// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet';
import AlertContainer from '../../alert/container/AlertContainer';
import Checkbox from '../../../elements/Checkbox/Checkbox';

import style from './UnsubscribeSuccess.scss';
import buttonStyle from '../../../assets/styles/button.scss';
import yogiUnsubscribe from '../../../assets/img/unsubscribe-success/yogi-unsubscribe.png';
import checkboxStyle from '../../../elements/Checkbox/Checkbox.scss';

import type { HTTPError } from '../../../error';
import type { User } from '../../../entities';

type Props = {
  +authenticated: boolean;
  +user: User;
  +editHasCampaignMailNewsletter: () => void;
  +isSubscribing?: boolean;
  +subscribeError?: HTTPError;
  +subscribeSuccess: boolean;
  +resetAlertState: () => void;
  +resetAlertErrorState: () => void;
  +authModalVisible?: boolean;
  +handleOpenAuthModal: (openLoginView?: boolean) => void;
};

type State = {
  resubscribe: boolean;
};

const messages = defineMessages({
  title: {
    id: 'unsubscriptionSuccess.document.title',
  },
  description: {
    id: 'unsubscriptionSuccess.document.description',
  },
});

export default class UnsubscribeSuccess extends Component<Props, State> {
  nextButtonPressHold = false;
  static defaultProps = {
    subscribeSuccess: false,
  };

  state = {
    resubscribe: false,
  };

  componentWillUnmount() {
    const { resetAlertState, resetAlertErrorState } = this.props;
    resetAlertState();
    resetAlertErrorState();
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { authModalVisible, user, authenticated } = this.props;
    // This means it was just authenticated and came from a "Next" button click
    if (this.nextButtonPressHold && user && authenticated) {
      this.handleSaveSubscription();
    }
    // This means: when the modal closes
    if (authModalVisible === false && prevProps.authModalVisible === true) {
      this.nextButtonPressHold = false;
    }
  }

  handleSaveSubscription() {
    const { editHasCampaignMailNewsletter, user, authenticated, handleOpenAuthModal } = this.props;
    if (!user || !authenticated) {
      if (handleOpenAuthModal instanceof Function) {
        this.nextButtonPressHold = true;
        handleOpenAuthModal();
        return;
      }
    }
    editHasCampaignMailNewsletter();
  }

  handleChange(e: Event) {
    if (e.target instanceof HTMLInputElement) {
      this.setState({ resubscribe: e.target.checked })
    }
  }

  render() {
    const { isSubscribing, subscribeSuccess } = this.props;
    const { resubscribe } = this.state;
    return (
      <Fragment>
        <Helmet>
          <title>{this.context.intl.formatMessage(messages.title)}</title>
          <meta name="description" content={this.context.intl.formatMessage(messages.description)}/>
        </Helmet>
        <section className={style.unsubscriptionSuccessWrap}>
          <AlertContainer showId="unsubscribe"/>
          <section className={classNames(style.unsubscriptionSuccess,
            { [style.disabled]: isSubscribing })}>
            <img className={style.yogi}
                 src={yogiUnsubscribe} alt="yogi-unsubscribe"/>
            <FormattedMessage id={subscribeSuccess ? 'unsubscriptionSuccess.title.resubscribe'
              : 'unsubscriptionSuccess.title.canceled'}>{
              txt => <h2 className={style.title}>{txt}</h2>
            }</FormattedMessage>
            <FormattedMessage id={subscribeSuccess ? 'unsubscriptionSuccess.subtitle.resubscribe'
              : 'unsubscriptionSuccess.subtitle.canceled'}>{
              txt => <p className={style.subtitle}>{txt}</p>
            }</FormattedMessage>
            {!subscribeSuccess &&
            <section className={style.bottomWrap}>
              <hr className={style.separator}/>
              <FormattedMessage id='unsubscriptionSuccess.resubscribe'>{
                txt => <Checkbox isChecked={resubscribe}
                                 handleChange={this.handleChange.bind(this)}
                                 name='resubscribe'
                                 value='resubscribe'
                                 className={checkboxStyle.acceptTerms}>{txt}</Checkbox>
              }</FormattedMessage>
              <FormattedMessage id='unsubscriptionSuccess.button.save'>{
                text => <button onClick={this.handleSaveSubscription.bind(this)}
                                className={classNames(buttonStyle.btn, buttonStyle.lightBlue,
                                  style.save)}
                                disabled={!resubscribe}>{text}</button>
              }</FormattedMessage>
            </section>}
          </section>
        </section>
      </Fragment>
    )
  }
}

UnsubscribeSuccess.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  editHasCampaignMailNewsletter: PropTypes.func.isRequired,
  isSubscribing: PropTypes.bool,
  subscribeError: PropTypes.object,
  subscribeSuccess: PropTypes.bool.isRequired,
  resetAlertState: PropTypes.func.isRequired,
  resetAlertErrorState: PropTypes.func.isRequired,
  handleOpenAuthModal: PropTypes.func.isRequired,
  authModalVisible: PropTypes.bool,
};

UnsubscribeSuccess.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/unsubscribe/components/UnsubscribeSuccess.jsx